"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schrader Dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorApi = exports.SensorApiFactory = exports.SensorApiFp = exports.SensorApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * SensorApi - axios parameter creator
 * @export
 */
var SensorApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary get aggregated sensor data
         * @param {number} machineId The id of the machine
         * @param {string} start Beginning of the time range to be retrieved
         * @param {string} end End of the time range to be retrieved
         * @param {AggregationMode} aggregationMode aggregation mode
         * @param {AggregationType} aggregationType aggregation type
         * @param {Array<string>} sensorNames Comma-separated list of sensors to be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorAggregates: function (machineId, start, end, aggregationMode, aggregationType, sensorNames, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'machineId' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorAggregates', 'machineId', machineId);
                            // verify required parameter 'start' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorAggregates', 'start', start);
                            // verify required parameter 'end' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorAggregates', 'end', end);
                            // verify required parameter 'aggregationMode' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorAggregates', 'aggregationMode', aggregationMode);
                            // verify required parameter 'aggregationType' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorAggregates', 'aggregationType', aggregationType);
                            // verify required parameter 'sensorNames' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorAggregates', 'sensorNames', sensorNames);
                            localVarPath = "/machines/{machineId}/sensors/aggregates"
                                .replace("{".concat("machineId", "}"), encodeURIComponent(String(machineId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (start !== undefined) {
                                localVarQueryParameter['start'] = (start instanceof Date) ?
                                    start.toISOString() :
                                    start;
                            }
                            if (end !== undefined) {
                                localVarQueryParameter['end'] = (end instanceof Date) ?
                                    end.toISOString() :
                                    end;
                            }
                            if (aggregationMode !== undefined) {
                                localVarQueryParameter['aggregationMode'] = aggregationMode;
                            }
                            if (aggregationType !== undefined) {
                                localVarQueryParameter['aggregationType'] = aggregationType;
                            }
                            if (sensorNames) {
                                localVarQueryParameter['sensorNames'] = sensorNames.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary get aggregated sensor data
         * @param {number} machineId The id of the machine
         * @param {string} start Beginning of the time range to be retrieved
         * @param {string} end End of the time range to be retrieved
         * @param {AggregationMode} aggregationMode aggregation mode
         * @param {Array<string>} sensorNames Comma-separated list of sensors to be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorMultiAggregates: function (machineId, start, end, aggregationMode, sensorNames, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'machineId' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorMultiAggregates', 'machineId', machineId);
                            // verify required parameter 'start' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorMultiAggregates', 'start', start);
                            // verify required parameter 'end' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorMultiAggregates', 'end', end);
                            // verify required parameter 'aggregationMode' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorMultiAggregates', 'aggregationMode', aggregationMode);
                            // verify required parameter 'sensorNames' is not null or undefined
                            (0, common_1.assertParamExists)('getSensorMultiAggregates', 'sensorNames', sensorNames);
                            localVarPath = "/machines/{machineId}/sensors/multiaggregates"
                                .replace("{".concat("machineId", "}"), encodeURIComponent(String(machineId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (start !== undefined) {
                                localVarQueryParameter['start'] = (start instanceof Date) ?
                                    start.toISOString() :
                                    start;
                            }
                            if (end !== undefined) {
                                localVarQueryParameter['end'] = (end instanceof Date) ?
                                    end.toISOString() :
                                    end;
                            }
                            if (aggregationMode !== undefined) {
                                localVarQueryParameter['aggregationMode'] = aggregationMode;
                            }
                            if (sensorNames) {
                                localVarQueryParameter['sensorNames'] = sensorNames.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary list available sensors for machine
         * @param {number} machineId The id of the machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensors: function (machineId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'machineId' is not null or undefined
                            (0, common_1.assertParamExists)('getSensors', 'machineId', machineId);
                            localVarPath = "/machines/{machineId}/sensors"
                                .replace("{".concat("machineId", "}"), encodeURIComponent(String(machineId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication BearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication BearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SensorApiAxiosParamCreator = SensorApiAxiosParamCreator;
/**
 * SensorApi - functional programming interface
 * @export
 */
var SensorApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SensorApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary get aggregated sensor data
         * @param {number} machineId The id of the machine
         * @param {string} start Beginning of the time range to be retrieved
         * @param {string} end End of the time range to be retrieved
         * @param {AggregationMode} aggregationMode aggregation mode
         * @param {AggregationType} aggregationType aggregation type
         * @param {Array<string>} sensorNames Comma-separated list of sensors to be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorAggregates: function (machineId, start, end, aggregationMode, aggregationType, sensorNames, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSensorAggregates(machineId, start, end, aggregationMode, aggregationType, sensorNames, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary get aggregated sensor data
         * @param {number} machineId The id of the machine
         * @param {string} start Beginning of the time range to be retrieved
         * @param {string} end End of the time range to be retrieved
         * @param {AggregationMode} aggregationMode aggregation mode
         * @param {Array<string>} sensorNames Comma-separated list of sensors to be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorMultiAggregates: function (machineId, start, end, aggregationMode, sensorNames, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSensorMultiAggregates(machineId, start, end, aggregationMode, sensorNames, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary list available sensors for machine
         * @param {number} machineId The id of the machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensors: function (machineId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSensors(machineId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SensorApiFp = SensorApiFp;
/**
 * SensorApi - factory interface
 * @export
 */
var SensorApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SensorApiFp)(configuration);
    return {
        /**
         *
         * @summary get aggregated sensor data
         * @param {number} machineId The id of the machine
         * @param {string} start Beginning of the time range to be retrieved
         * @param {string} end End of the time range to be retrieved
         * @param {AggregationMode} aggregationMode aggregation mode
         * @param {AggregationType} aggregationType aggregation type
         * @param {Array<string>} sensorNames Comma-separated list of sensors to be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorAggregates: function (machineId, start, end, aggregationMode, aggregationType, sensorNames, options) {
            return localVarFp.getSensorAggregates(machineId, start, end, aggregationMode, aggregationType, sensorNames, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary get aggregated sensor data
         * @param {number} machineId The id of the machine
         * @param {string} start Beginning of the time range to be retrieved
         * @param {string} end End of the time range to be retrieved
         * @param {AggregationMode} aggregationMode aggregation mode
         * @param {Array<string>} sensorNames Comma-separated list of sensors to be returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensorMultiAggregates: function (machineId, start, end, aggregationMode, sensorNames, options) {
            return localVarFp.getSensorMultiAggregates(machineId, start, end, aggregationMode, sensorNames, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary list available sensors for machine
         * @param {number} machineId The id of the machine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensors: function (machineId, options) {
            return localVarFp.getSensors(machineId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SensorApiFactory = SensorApiFactory;
/**
 * SensorApi - object-oriented interface
 * @export
 * @class SensorApi
 * @extends {BaseAPI}
 */
var SensorApi = /** @class */ (function (_super) {
    __extends(SensorApi, _super);
    function SensorApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary get aggregated sensor data
     * @param {number} machineId The id of the machine
     * @param {string} start Beginning of the time range to be retrieved
     * @param {string} end End of the time range to be retrieved
     * @param {AggregationMode} aggregationMode aggregation mode
     * @param {AggregationType} aggregationType aggregation type
     * @param {Array<string>} sensorNames Comma-separated list of sensors to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    SensorApi.prototype.getSensorAggregates = function (machineId, start, end, aggregationMode, aggregationType, sensorNames, options) {
        var _this = this;
        return (0, exports.SensorApiFp)(this.configuration).getSensorAggregates(machineId, start, end, aggregationMode, aggregationType, sensorNames, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary get aggregated sensor data
     * @param {number} machineId The id of the machine
     * @param {string} start Beginning of the time range to be retrieved
     * @param {string} end End of the time range to be retrieved
     * @param {AggregationMode} aggregationMode aggregation mode
     * @param {Array<string>} sensorNames Comma-separated list of sensors to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    SensorApi.prototype.getSensorMultiAggregates = function (machineId, start, end, aggregationMode, sensorNames, options) {
        var _this = this;
        return (0, exports.SensorApiFp)(this.configuration).getSensorMultiAggregates(machineId, start, end, aggregationMode, sensorNames, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary list available sensors for machine
     * @param {number} machineId The id of the machine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SensorApi
     */
    SensorApi.prototype.getSensors = function (machineId, options) {
        var _this = this;
        return (0, exports.SensorApiFp)(this.configuration).getSensors(machineId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SensorApi;
}(base_1.BaseAPI));
exports.SensorApi = SensorApi;
